<template>
  <div class="chart_main">
    <dv-border-box-10 class="border_box10">
      <div class="dv_title">
        <div class="title">货物分布信息</div>
        <div><dv-decoration-3 :key="key" class="title_line" /></div>
      </div>
      <div class="dv_ring_chart">
        <dv-active-ring-chart
          :config="config1"
          :key="key1"
          class="ring_chart"
        />
      </div>
      <div>
        <dv-decoration-4
          :reverse="true"
          :key="key3"
          style="width:100%;height:5px;"
        />
      </div>
      <div class="dv_title">
        <div class="title">货物区域分布</div>
        <div><dv-decoration-3 :key="key4" class="title_line" /></div>
      </div>
      <div class="dv_capsule_chart">
        <dv-capsule-chart
          :config="config2"
          :key="key5"
          style="width:100%;height:400px"
        />
      </div>
      <div>
        <dv-decoration-4
          :reverse="true"
          :key="key6"
          style="width:100%;height:5px;"
        />
      </div>
      <div class="dv_title">
        <div class="title">货物出入库记录</div>
        <div><dv-decoration-3 :key="key7" class="title_line" /></div>
      </div>
      <div class="dv_table">
        <dv-scroll-board
          :config="config3"
          :key="key8"
          class="scroll_board"
          style=""
        />
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
import vue from "vue";
import dataV from "@jiaminghi/data-view";

vue.use(dataV);

export default {
  props: ["req_url"],
  name: "DataVChart",
  data() {
    return {
      key: 1,
      key1: 1,
      key2: 1,
      key3: 1,
      key4: 1,
      key5: 1,
      key6: 1,
      key7: 1,
      key8: 1,
      config1: {
        data: [
          {
            name: "周口",
            value: 55,
          },
          {
            name: "南阳",
            value: 120,
          },
          {
            name: "西峡",
            value: 78,
          },
          {
            name: "驻马店",
            value: 66,
          },
          {
            name: "新乡",
            value: 80,
          },
        ],
      },
      config2: {
        data: [
          {
            name: "南阳",
            value: 167,
          },
          {
            name: "周口",
            value: 123,
          },
          {
            name: "漯河",
            value: 98,
          },
          {
            name: "郑州",
            value: 75,
          },
          {
            name: "西峡",
            value: 66,
          },
          {
            name: "湖州",
            value: 60,
          },
          {
            name: "江苏",
            value: 86,
          },
          {
            name: "义乌",
            value: 136,
          },
          {
            name: "上海",
            value: 46,
          },
        ],
        colors: ["#e062ae", "#fb7293", "#e690d1", "#32c5e9", "#96bfff"],
        unit: "吨",
        showValue: true,
      },
      config3: {
        header: ["列1", "列2", "列3"],
        data: [
          ["行1列1", "行1列2", "行1列3"],
          ["行2列1", "行2列2", "行2列3"],
          ["行3列1", "行3列2", "行3列3"],
          ["行4列1", "行4列2", "行4列3"],
          ["行5列1", "行5列2", "行5列3"],
          ["行6列1", "行6列2", "行6列3"],
          ["行7列1", "行7列2", "行7列3"],
          ["行8列1", "行8列2", "行8列3"],
          ["行9列1", "行9列2", "行9列3"],
          ["行10列1", "行10列2", "行10列3"],
        ],
        index: true,
        rowNum: 7,
        indexHeader: "序号",
        columnWidth: [50],
        align: ["center"],
      },
      config4: {
        number: [127],
        content: "{nt}吨",
      },
      config5: {
        header: ["时间", "类型", "数量"],
        rowNum: 7,
        headerBGC: "#494fb3",
        align: ["center", "center", "center"],
        data: [
          ["2021/1/1", "入库", "30吨"],
          ["2021/1/1", "入库", "32吨"],
          ["2021/1/1", "出库", "28吨"],
          ["2021/1/1", "出库", "20吨"],
          ["2021/1/3", "入库", "27吨"],
          ["2021/1/3", "出库", "27吨"],
          ["2021/1/3", "入库", "24吨"],
          ["2021/1/3", "出库", "2吨"],
          ["2021/1/3", "入库", "27吨"],
          ["2021/1/3", "出库", "21吨"],
        ],
      },
      dataVData: null,
      url: this.req_url,
      domWidth: 0,
      domHeight: 0,
      currBorderWidth: 0,
      currBorderHeight: 0,
    };
  },
  mounted() {
    window.addEventListener("resize", () => this.onWindowResize(), false);
  },
  methods: {
    onWindowResize: function() {
      this.key += 1;
      this.key1 += 1;
      this.key2 += 1;
      this.key3 += 1;
      this.key4 += 1;
      this.key5 += 1;
      this.key6 += 1;
      this.key7 += 1;
      this.key8 += 1;

      this.$nextTick;
    },
  },
};
</script>

<style scoped>
.dv_table {
  padding-top: 10px;
  padding-bottom: 10px;
}
.scroll_board {
  width: 85%;
  height: 420px;
  margin: auto;
}

.dv_capsule_chart {
  width: 85%;
  margin: auto;
}

.ring_chart {
  width: 12vw;
  height: 21vh;
  margin: auto;
}

.dv_ring_chart {
  width: 100%;
}

.dv_title {
  padding-top: 10px;
  padding-left: 20px;
}

.title_line {
  width: 95%;
  height: 30px;
}

.title {
  font-size: 18px;
}

.chart_main {
  width: 100%;
  color: rgb(252, 243, 243);
}

@media screen and (max-width: 1300px) {
  .title {
    font-size: 16px;
  }
}

@media screen and (max-width: 1000px) {
  .title {
    font-size: 14px;
  }
}

@media screen and (max-width: 800px) {
  .title {
    font-size: 12px;
  }
}
</style>
